import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useNavigationType } from "react-router-dom";
import { useSelector } from "react-redux";
import Appointment from "../../../Models/Appointment/Appointment";
import { RequestLayout } from "../../common/components/RequestLayout";
import { getNextStepPath, stepLayoutItemsId } from "../../../Utils";
import Media from "../../../Models/Media/Media";
import { SelectBranchComponent } from "../../common/components/SelectBranchComponent";
import { css } from "aphrodite";
import styles from "./styles";
import { StepInfo } from "../../common/components/StepInfo";
import { CommonLayout } from "../../common/components/CommonLayout";
import Logger from "../../../Utils/Logger";
import { RoutePath } from "../../../Utils/routePath";

const SelectBranchPage = () => {
    const navigate = useNavigate();
    const navigationType = useNavigationType();
    const currentStep = stepLayoutItemsId.selectBranch;
    const serviceId = useSelector(Appointment.getSelectedServiceId);
    const serviceGroupId = useSelector(Appointment.getSelectedServiceGroupId);
    const selectedSubServiceGroupId = useSelector(Appointment.getSelectedSubServiceGroupId);
    const isLoading = useSelector(Appointment.getBranchesLoading);
    const branchesData = useSelector(Appointment.getBranchesData);
    const selectedBranchId = useSelector(Appointment.getSelectedBranchId);
    const error = useSelector(Appointment.getBranchesError);
    const webView = useSelector(Media.getIsWebView);
    const stepItems = useSelector(Appointment.getStepItems);
    const isAppointmentByBranch = useSelector(Appointment.getIsAppointmentByBranch);
    const servicesData = useSelector(Appointment.getServicesData);

    useEffect(() => {
        if (!isAppointmentByBranch && !serviceId && navigationType === 'POP') {
            if (selectedSubServiceGroupId) {
                navigate(RoutePath.selectSubServicePage, { replace: true });
            } else {
                navigate(RoutePath.selectServicePage, { replace: true });
            }
        }
    }, [serviceId, selectedSubServiceGroupId, isAppointmentByBranch, navigationType, navigate]);

    useEffect(() => {
        if (branchesData && branchesData.length > 0) {
            return;
        }
        
        if (!serviceGroupId) {
            if (serviceId && !isAppointmentByBranch) {
                Appointment.fetchBranches(serviceId);
            } else if (isAppointmentByBranch) {
                Appointment.fetchBranches();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceId, isAppointmentByBranch, serviceGroupId]);

    useEffect(() => {
        if (branchesData && branchesData.length > 0) {
            return;
        }
        
        if (!serviceId && serviceGroupId && Array.isArray(servicesData) && servicesData.length > 0) {
            const serviceIds = servicesData.filter(s => s.tags?.ServiceGroupId === serviceGroupId).map(s => s.id);
            Appointment.fetchGroupBranches(serviceIds);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceId, serviceGroupId, servicesData]);

    const handleOnBranchSelect = async (id, name, organisationId) => {
        try {
            if (serviceGroupId) {
                const selectedBranch = branchesData.find(b => b.id === id);
                if (selectedBranch) {
                    const serviceId = selectedBranch.serviceId;
                    const service = servicesData.find(s => s.id === serviceId);
                    Appointment.setSelectedService(
                        serviceId, service.eventTypeId, service.name, service.description);
                    const waysOfAction = await Appointment.fetchWaysOfAction(service.eventTypeId);
                    Appointment.setSelectedChannel(
                        waysOfAction?.data?.availableChannels[0]
                    );
                }
            }
            Appointment.setSelectedBranch(id, name, organisationId);
            Appointment.stepCompleted(currentStep);
            navigate(getNextStepPath(currentStep, stepItems));
        } catch (e) {
            Logger.log(e, 'SelectBranchPage@handleOnBranchSelect Exception: ')
        }
    }

    return (
        <div className={css(styles.container)}>
            <CommonLayout mainLayout={false}>
                <StepInfo activeStepId={currentStep} layoutItems={stepItems} webView={webView} />
            </CommonLayout>
            <RequestLayout loading={isLoading} error={error}>
                {branchesData && (
                    <SelectBranchComponent
                        selectedBranchId={selectedBranchId}
                        webView={webView}
                        branches={branchesData.map((item) => ({
                            ...item,
                            latitude: item?.latitude || 0,
                            longitude: item?.longitude || 0,
                        }))}
                        onBranchSelect={handleOnBranchSelect}
                    />
                )}
            </RequestLayout>
        </div>
    );
};

const memoizedSelectBranchPage = React.memo(SelectBranchPage);
export { memoizedSelectBranchPage as SelectBranchPage };
